import Aiguille from "./games/Aiguille";
import Hunter from "./games/Hunter";
import PouleRenardVipere from "./games/PouleRenardVipere";

export const GamesList = [
    {
        name: 'Aiguille',
        class: Aiguille
    },
    {
        name: 'Hunter',
        class: Hunter
    },
    {
        name: 'PouleRenardVipere',
        class: PouleRenardVipere
    }
]

